import { combineReducers, createStore } from 'redux';
import * as userReducers from './user-duck';
import { USER_CREATE,  userCreate} from './user-duck';

const rootReducer = combineReducers(userReducers);

const token = localStorage.getItem('token');

const rStore = createStore(rootReducer, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());

rStore.dispatch({ type: USER_CREATE });

rStore.dispatch(userCreate({
    token
}));

export const store = rStore;
